module.exports = __webpack_public_path__ + "static/code-talks-77a8f0e947fe99c2b7939acd164f8411.png";